<template>
  <el-container class="layout-container">
    <el-aside width="200px" class="layout-aside">
      <div class="logo">后台管理</div>
      <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          router
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
      >
        <template v-for="route in menuRoutes" :key="route.path">
          <!-- 只显示一级菜单，不显示子菜单 -->
          <el-menu-item :index="resolvePath(route.path)">
            <el-icon><component :is="route.meta.icon" /></el-icon>
            <span>{{ $t(route.meta.title) }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="layout-header">
        <div class="header-left">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
              {{ $t(item.meta.title) }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ userStore.userInfo?.username || '用户' }}
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout" divided>登出</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-select v-model="locale" @change="handleLanguageChange" style="width: 120px; margin-left: 20px;">
            <el-option label="繁体中文" value="tc" />
            <el-option label="简体中文" value="cn" />
            <el-option label="English" value="en" />
          </el-select>
        </div>
      </el-header>
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const { locale } = useI18n()

const menuRoutes = computed(() => {
  const layoutRoute = router.options.routes.find(r => r.name === 'Layout')
  if (!layoutRoute || !layoutRoute.children) return []
  return layoutRoute.children.filter(r => !r.meta.hidden)
})

// 修复路径解析函数
const resolvePath = (basePath, childPath = '') => {
  // 确保 basePath 以 / 开头
  const normalizedBase = basePath.startsWith('/') ? basePath : `/${basePath}`

  if (!childPath) {
    return normalizedBase
  }

  // 处理子路径，移除可能的前导斜杠
  const normalizedChild = childPath.startsWith('/') ? childPath.slice(1) : childPath
  return `${normalizedBase}/${normalizedChild}`
}

const activeMenu = computed(() => {
  const { path } = route
  return path
})

const breadcrumbList = ref([])
watch(route, (newRoute) => {
  const matched = newRoute.matched.filter(item => item.meta && item.meta.title)
  breadcrumbList.value = matched
}, { immediate: true })

const handleLanguageChange = (val) => {
  locale.value = val
  localStorage.setItem('lang', val)
}

const handleCommand = (command) => {
  if (command === 'logout') {
    userStore.logout()
    router.push('/login')
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.layout-aside {
  background-color: #545c64;
  color: #fff;
  transition: width 0.3s;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffd04b;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.layout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.layout-main {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>